(() => {
  const signup = document.querySelector('[data-forms-id="forms-root-1178224"]');
  if (!signup || !('IntersectionObserver' in window)) return;
  const mobile = window.matchMedia('(max-width: 640px)');
  let visible = false;
  const update = () => document.documentElement.toggleAttribute('data-gtd-inline-signup-visible', mobile.matches && visible);
  const observer = new IntersectionObserver(([entry]) => {
    visible = entry.isIntersecting;
    update();
  });
  observer.observe(signup);
  mobile.addEventListener('change', update);
})();
